import WatchListEntryTableRow from './WatchListEntryTableRow';

export default WatchListEntryTableRow;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry-high-risk-country/components/watch-list-entries-table/watch-list-entry-table-row/index.js